import {components, type DropdownIndicatorProps} from 'react-select';

import type {SelectV2} from '../Select.v2';

import ArrowDownSvg from '../../../../assets/icons/secondary/Arrow - Down 2.svg';
import {Icon} from '../../../Icon';

export const SelectDropdownIndicatorV2 = (
  props: SelectDropdownIndicatorV2.Props,
) => {
  const size = props.size === 'xs' ? 8 : 18;

  return (
    <components.DropdownIndicator {...props}>
      <Icon color={'icon.gray'} size={size} svg={ArrowDownSvg} />
    </components.DropdownIndicator>
  );
};

export namespace SelectDropdownIndicatorV2 {
  export type Props = DropdownIndicatorProps<unknown, true> &
    Required<Pick<SelectV2.Props, 'size'>>;
}
